import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';

@Component({
    components: {},
})
export default class SBText extends Mixins(SBComponentVue) {
    @Prop({
        type: Boolean,
        default: false,
    })
    public errorIcon!: boolean;
}
